import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

export const useSetInactivity = () => {
  const { dispatch } = useCampaignEditorContext();
  return useCallback(
    (inactivity: number) =>
      dispatch({
        type: 'SET_INACTIVITY_DURATION_TIMER',
        payload: {
          duration: !!inactivity && inactivity >= 0 ? inactivity : null,
        },
      }),
    [dispatch],
  );
};
